module.exports = __webpack_public_path__ + "img/sac-atendimento.0b7203b6.png";